<template>
  <div class="flex flex-col my-auto">
    <div class="flex mx-auto mb-6">
      <div @click="cardClick('sub-general-one')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">PREVIEW</h4>
      </div>
      <div @click="cardClick('sub-general-two')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">SOCIAL VS. <br>INSIDE</h4>
      </div>
      <div @click="cardClick('sub-general-three')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">NEXT BILLION <br>USERS</h4>
      </div>
      <div @click="cardClick('sub-general-four')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">CREATIVE <br>CONCEPT</h4>
      </div>
    </div>

    <div class="flex m-auto">
      <div @click="cardClick('sub-general-five')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">GUARANTY</h4>
      </div>
      <div @click="cardClick('sub-general-six')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">GENERAL <br>STRUCTURE</h4>
      </div>
      <div @click="cardClick('sub-general-seven')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">INTRINSIC <br>AI</h4>
      </div>
      <div @click="cardClick('sub-general-eight')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">NEURO <br>RITUALS </h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GeneralIndex",
  methods:{
    cardClick(cardName){
      Event.$emit('clickedCard', cardName);
    }
  }
}
</script>

<style lang="css" scoped>
.circles{
  width: 14rem;
  height: 14rem;
}

@media (min-width: 1024px){

  .circles{
    width: 11rem;
    height: 11rem;
  }

}

@media (min-width: 1280px){

  .circles{
    width: 12rem;
    height: 12rem;
  }

}

@media (min-width: 1367px){

  .circles{
    width: 14rem;
    height: 14rem;
  }

}

@media (min-width: 1500px){

  .circles{
    width: 12rem;
    height: 12rem;
  }

}

@media (min-width: 1550px){

  .circles{
    width: 14rem;
    height: 14rem;
  }

}

@media (min-width: 2000px){

  .circles{
    width: 18rem;
    height: 18rem;
  }

}
</style>
